(function() {
  var ScrollHelper, StepHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepHandler = App.loadClass('grower::handlers/placement/StepHandler');

  ScrollHelper = App.load('core::ScrollHelper');

  exports.SeedOptionsHandler = (function(superClass) {
    extend(SeedOptionsHandler, superClass);

    function SeedOptionsHandler() {
      return SeedOptionsHandler.__super__.constructor.apply(this, arguments);
    }

    SeedOptionsHandler.prototype.setInitialDeps = function() {
      SeedOptionsHandler.__super__.setInitialDeps.call(this);
      return this.syncDeps({
        'Seed_Options_Selections': 'grower::viewmodels/placement/seed_options/Selections',
        'Seed_Options_Form': 'grower::viewmodels/placement/seed_options/Form'
      });
    };

    SeedOptionsHandler.prototype.afterLoadLayout = function(selector, data) {
      var anim, customButton, customButtons, i, id, len1, progressbars, ref, self;
      self = this;
      this.moveStepContent();
      this.parent._handleResize();
      this.msg = $(this.parent.layoutSelector).find('.message_writer').message_writer({
        autoHide: false
      });
      this.selectionsKO = new (this.getDep('Seed_Options_Selections'))(this);
      ko.cleanNode($(this.sidebar.layoutSelector).find('.spp-units-display')[0]);
      ko.applyBindings(this.selectionsKO, $(this.sidebar.layoutSelector).find('.spp-units-display')[0]);
      this.stepKO = new (this.getDep('Seed_Options_Form'))(this);
      ko.cleanNode(this.parent.dialog[0]);
      ko.applyBindings(this.stepKO, this.parent.dialog[0]);
      this.msg = $(this.parent.layoutSelector).find('.message_writer').message_writer({
        autoHide: false,
        hideTime: 10000
      });
      this.parent.dialog.find('#back_button').on('click', (function(_this) {
        return function() {
          return _this.parent.goToStep(_this.num - 1);
        };
      })(this));

      /*
      Each button is defined with properties named 'html' and 'click'.
      
      For convention's sake, if you are defining exactly one button (e.g.
      Burrus), then use ".customButton" and simply create the button object:
      
      @customButton =
          'html': '<button class="btn btn-blue"><i class="fa fa-file-o"></i> Placement Summary Report</button>'
          'click': () =>
              layers = @curStep.stepKO.plantingPlans()
              @actionPdf(layers)
      
      If you are defining multiple buttons (e.g. Legend), then use
      ".customButtons", and create an array of button objects:
      
      @customButtons = [
          {
              'html': '<button class="btn btn-primary pull-left">
                      <i class="fa fa-file-o"></i> Summary Report
                  </button>'
              'click': () =>
                  layers = @curStep.stepKO.plantingPlans()
                  @actionPdf(layers)
          }
          {
              'html': '<button class="btn btn-blue pull-right">
                      <i class="fa fa-chevron-right"></i> Place Order
                  </button>'
              'click': () =>
                  orderLines = []
                  for v,k in @curStep.selectionsKO.hybrids()
                      orderLines.push
                          product:    v.productID
                          tmt:        v.treatmentID
                          qty:        v.units
      
                   * create the Legend Orders handler
                  order = @curStep.createSubHandler 'Grower.Legend_Orders_Dialog_Handler'
                  if order
                      order.data =
                          lines: orderLines
                      order.init()
          }
      ]
      
      (Technically, ".customButton" and ".customButtons" are interchangeable,
      because it is both better practice and easier to do that way, but the
      convention exists to make your code clearer. Also, you could put a
      single button in an array if you really wanted to, but that would be
      kind of pointless.)
       */
      $('.spp-custom-content').empty();
      customButtons = (ref = this.parent.customButtons) != null ? ref : this.parent.customButton;
      if (customButtons != null) {
        if (!(customButtons instanceof Array)) {
          customButtons = [customButtons];
        }
        for (i = 0, len1 = customButtons.length; i < len1; i++) {
          customButton = customButtons[i];
          $(customButton.html).on('click', customButton.click).appendTo('.spp-custom-content');
        }
        this.showCustomButtons();
        this.selectionsKO.hybrids.subscribe((function(_this) {
          return function(hybrids) {
            return _this.showCustomButtons();
          };
        })(this));
      }
      if (!this.parent.makes_recommendations || (this.parent.finished && !this.parent.inputChanged)) {
        this.stepKO.endProcessing();
      } else {
        progressbars = $('.spp-progress .bar');
        id = 0;
        anim = function(elem) {
          var len, maxBarTime, minBarTime;
          if (true) {
            minBarTime = 500;
            maxBarTime = 1500;
          } else {
            minBarTime = 0;
            maxBarTime = 0;
          }
          len = Math.floor(Math.random() * (maxBarTime - minBarTime) + minBarTime);
          return elem.animate({
            width: ['100%', 'swing']
          }, len, function() {
            id++;
            if (progressbars.eq(id).length > 0) {
              return anim(progressbars.eq(id));
            } else {
              return self.stepKO.doneProcessing(true);
            }
          });
        };
        anim(progressbars.eq(0));
      }
      this.sidebar.stepListKO.setCurrent(this.id);
      return this.parent.inputChanged = false;
    };

    SeedOptionsHandler.prototype.setupDatatable = function() {
      if (!$('.spp-units-display table').hasClass('dataTable')) {
        return ScrollHelper.make($('#table-units'), {
          height: '230'
        });
      }
    };

    SeedOptionsHandler.prototype.showCustomButtons = function(hybrids) {
      if (hybrids == null) {
        hybrids = this.selectionsKO.hybrids();
      }
      if (!this.stepKO.processing() && hybrids.length > 0) {
        return $('.spp-custom-content').show();
      } else {
        return $('.spp-custom-content').hide();
      }
    };

    SeedOptionsHandler.prototype.showSkippedFieldsDialog = function() {
      var dlg, self, spp;
      self = this;
      spp = this.parent;
      dlg = this.createSubHandler('core::DialogHandler');
      if (dlg) {
        dlg.init = function() {
          this.resizable = false;
          this.defaultSave = false;
          this.layoutUrl = 'backend/grower/placement/spp/load-skipped-fields-layout';
          this.loadLayoutPostOptions = {
            id: spp.sppID
          };
          this.classes = 'small_dialog';
          this.submitAction = function() {
            self.stepKO.goToFirstSkippedField();
            return this.destroy();
          };
          return this.createDialog();
        };
        dlg.afterLoadLayout = function() {
          this.dialog.find('.cancel-btn').on('click', function() {
            return self.stepKO.finishSPP();
          });
          return this.openDialog();
        };
        return dlg.init();
      }
    };

    SeedOptionsHandler.prototype.showFinishedDialog = function() {
      var dlg, spp;
      dlg = this.createSubHandler('core::DialogHandler');
      if (dlg) {
        spp = this.parent;
        dlg.init = function() {
          this.resizable = false;
          this.defaultSave = false;
          this.layoutUrl = 'backend/grower/placement/spp/load-finished-layout';
          this.loadLayoutPostOptions = {
            id: spp.sppID
          };
          this.classes = 'small_dialog';
          this.submitAction = function() {
            spp.parent.refresh();
            return this.destroy();
          };
          return this.createDialog();
        };
        dlg.afterLoadLayout = function() {
          return this.openDialog();
        };
        return dlg.init();
      }
    };

    SeedOptionsHandler.prototype.applyFieldsAspects = function() {};

    SeedOptionsHandler.prototype.updateFieldsAspects = function() {};

    SeedOptionsHandler.prototype.destroy = function() {
      $('.spp-units-display').hide();
      $('.spp-units-display #tbody-units').empty();
      $('.spp-custom-content').empty();
      $('#reset_survey_button').removeClass('btn-primary');
      $(window).off('spp.planting-plan-saved');
      $(window).off('spp.planting-plans-copied');
      return SeedOptionsHandler.__super__.destroy.call(this);
    };

    return SeedOptionsHandler;

  })(StepHandler);

}).call(this);
